/** The canonical 9-slide framework (classification keys + display fallbacks). */
export const FRAMEWORK_SLIDES: { key: string; label: string }[] = [
  { key: 'problem', label: 'Problem' },
  { key: 'solution', label: 'Solution' },
  { key: 'marketSize', label: 'Market Size' },
  { key: 'howItWorks', label: 'How It Works' },
  { key: 'traction', label: 'Traction' },
  { key: 'competition', label: 'Competition' },
  { key: 'team', label: 'Team' },
  { key: 'funding', label: 'Funding' },
  { key: 'financials', label: 'Financials' },
]
